module.exports = __webpack_public_path__ + "static/2-e0056a83f5f582c7120fe8050dd39bdd.jpg";